// Define and export the player item type
export const ItemTypes = {
  PLAYER: 'player',
};